module.exports = __webpack_public_path__ + "static/media/acai_berry_brushes.bfa3ed97.png";